import React, { useEffect, useRef, useContext } from 'react'
import PageContext from '@contexts/pageContext'

import { useOutsideClick, useSetState } from '@campaignhub/react-hooks'
import { Box, FormField, Text } from '@campaignhub/suit-theme'

import custom from '@styles/custom.module.scss'

import classifications from '@functions/classifications'

const defaultState = {
  showFilter: false,
}

const ClassificationFilter = () => {
  const [state, setState] = useSetState(defaultState)
  const { showFilter } = state

  const { callbacks: { toggleSelectedClassification }, selectedClassification } = useContext(PageContext)

  const contentEl = useRef()
  const [isClickedOutside, setIsClickedOutside] = useOutsideClick(contentEl, { enabled: showFilter })

  useEffect(() => {
    if (isClickedOutside && showFilter){
      setState({ showFilter: !showFilter })
      setIsClickedOutside(false)
    }
  }, [isClickedOutside])

  return (
    <FormField direction="column">
      <Box className={custom.root} ref={contentEl}>
        <select
          onMouseDown={(e) => {
            e.preventDefault()
            setState({ showFilter: !showFilter })
          }}
          value="Classification"
        >
          <option>Classification</option>
        </select>

        {showFilter && (
        <Box className={custom.popup}>
          <Box flexDirection="column" maxHeight="280px" overflowY="auto">
            {Object.values(classifications).map(classification => (
              <>
                <Box flexDirection="row" paddingTop="small" paddingBottom="medium" alignItems="center">
                  <input
                    className={custom.checkbox}
                    onChange={e => toggleSelectedClassification(e.target.checked, classification.name)}
                    type="checkbox"
                    checked={selectedClassification.includes(classification.name)}
                  />
                  <Text fontSize="small" marginLeft="medium">{classification.name}</Text>
                </Box>
              </>
                ))}
          </Box>
        </Box>
            )}
      </Box>
    </FormField>
  )
}

export default ClassificationFilter
